export default {
  wallActive: 0,
  interiors: null,
  interiorActive: '',
  windowActive: '',
  windows: null,
}
